import React from 'react'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import { useSearchParam } from 'hooks/useSearchParams'

export default function Vignette({ visible, fullScreen, clearParams, onClick }) {
  const history = useHistory()
  const location = useLocation()

  const { clearMany } = useSearchParam()

  if (!visible) return null

  const handleClick = () => {
    if (clearParams) {
      clearMany(clearParams)
    } else {
      history.push(location.pathname)
    }
  }

  return (
    <div
      onClick={onClick || handleClick}
      style={{
        position: fullScreen ? 'fixed' : 'relative',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(1,1,1, 0.15)',
        zIndex: 999998,
      }}
    />
  )
}

Vignette.propTypes = {
  visible: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool,
  clearParams: PropTypes.array,
  onClick: PropTypes.func,
}
